import { useEffect, useState } from 'react'
import { Box, Link } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCheckAuth, useTranslate } from 'ra-core'
import logo from './../resources/freeBILL_logo.png'
import CustomFooter from '../customStyles/CustomFooter'
import Login from './Login'
import { Register } from './Register'
import { SendResetPassword } from './SendResetPassword'
import { ResetPassword } from './ResetPassword'
import { SetupUserLogin } from './SetupUserLogin'

export type LoginPageType = "login" | "register" | "setupUserLogin" | "sendResetPassword" | "resetPassword"

function getPage(loginPageType?: string | null) {
  var result: LoginPageType = "login"
  const allLoginPageTypes = ["login", "register", "setupUserLogin", "sendResetPassword", "resetPassword"]
  if(loginPageType && allLoginPageTypes.includes(loginPageType))
    result = loginPageType as LoginPageType
  return result
}

export const LoginPage = () => {    

    const [page, setPage] = useState<LoginPageType>("login")
    
    const checkAuth = useCheckAuth()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const translate = useTranslate()

    const checkPage = () => {
      var pageFromQuery = searchParams.get("page")
      setPage(getPage(pageFromQuery))
    }

    useEffect(() => {
        checkPage()
        checkAuth({}, false)
            .then(() => {
                // already authenticated, redirect to the home page
                navigate('/#/')
            })
            .catch(() => {
                // not authenticated, stay on the login page
            })
    }, [checkAuth, navigate])
    
    return (
      <Box>
        <Box px={8} display={"flex"} height={50} width={"100%"} sx={{backgroundColor: "white"}} alignItems={"center"} justifyContent={"space-between"}>
          <Box 
            component={"img"}
            sx={{height: 28}}
            src={logo}
          />
          { page !== "login" && <Link sx={{cursor: "pointer"}} onClick={() => setPage("login")}>{translate("resources.authentication.login.login")}</Link> }
        </Box>
        { page === "login" && <Login setPage={setPage} /> }
        { page === "register" && <Register /> }
        { page === "sendResetPassword" && <SendResetPassword /> }
        { page === "resetPassword" && <ResetPassword /> }
        { page === "setupUserLogin" && <SetupUserLogin /> }
        <CustomFooter />
      </Box>
    )
}
